const ACTIONS = {
    ORDER_CURRENT_REQUEST_SUCCESS: "ORDER_CURRENT_REQUEST_SUCCESS",
    SET_ORDER_COMMENT_FORM_STATE: "SET_ORDER_COMMENT_FORM_STATE",
    DELETE_ORDER_COMMENT_FORM_STATE: "DELETE_ORDER_COMMENT_FORM_STATE",
};

const initialState = {
    currentData: {},
    commentFormState: {},
};

export default (state = initialState, action) => {
    switch (action.type) {
        case ACTIONS.ORDER_CURRENT_REQUEST_SUCCESS: {
            return { ...state, currentData: action.result };
        }

        case ACTIONS.SET_ORDER_COMMENT_FORM_STATE: {
            const { commentFormState, id } = action;
            return { ...state, commentFormState: { ...state.commentFormState, [id]: commentFormState } };
        }
        case ACTIONS.DELETE_ORDER_COMMENT_FORM_STATE: {
            const { id } = action;
            delete state.commentFormState[id];
            return state;
        }

        default: {
            return state;
        }
    }
};

export const setCurrentData = result => ({
    type: ACTIONS.ORDER_CURRENT_REQUEST_SUCCESS,
    result,
});

export const setOrderCommentFormState = (orderId, commentFormState) => ({
    type: ACTIONS.SET_ORDER_COMMENT_FORM_STATE,
    id: orderId,
    commentFormState,
});

export const deleteOrderCommentFormState = orderId => ({
    type: ACTIONS.DELETE_ORDER_COMMENT_FORM_STATE,
    id: orderId,
});
